import { createFileRoute } from '@tanstack/react-router';
import SearchResultsPage from '../components/SearchResultsPage';
import { validateSearchParams } from '../services/search';

export const Route = createFileRoute('/_app/search')({
  component: SearchPage,
  validateSearch: validateSearchParams,
});

function SearchPage() {
  const { q, site, author, sort, page } = Route.useSearch();
  const navigate = Route.useNavigate();

  const updatePageSearch = (nextPage: number) => {
    const safePage = Math.max(1, nextPage);
    navigate({
      replace: true,
      search: (prev) => {
        if (safePage <= 1) {
          if (prev.page === undefined) return prev;
          const { page: _page, ...rest } = prev;
          return rest;
        }
        if (prev.page === safePage) return prev;
        return { ...prev, page: safePage };
      },
    });
  };

  return (
    <SearchResultsPage
      q={q}
      site={site}
      author={author}
      sort={sort}
      page={page}
      onPageChange={updatePageSearch}
    />
  );
}
